import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'adc-sidenav',
  templateUrl: './adc-sidenav.component.html',
  styleUrls: ['./adc-sidenav.component.scss'],
  standalone: false
})
export class AdcSidenavComponent {
  @ViewChild("popup") popup: ElementRef | undefined;
  @HostListener("document:click", ["$event"])
  onClick(event: Event) {
    if (
      this.popup &&
      !this.popup.nativeElement.contains(event.target)
    ) {
      this.subMenuId = [];
    }
  }
  @Input('type') type: any;
  @Input('data') data: any;
  @Input() sidebarOpen !: boolean;
  @Output() navigationId: EventEmitter<any>;
  
  showLogo: boolean;
  rightSidebarOpen: boolean;
  activeId : any = 1;
  activeId2 : any = 1;
  childActiveId: any;
  grandChildActiveId: any;
  thirdLevelActiveId: any;
  // secondLevelMenu: boolean = false;
  secondLevelMenuId: any;
  childrenOpened: boolean = false;
  // activeId: number | null = null;
  // secondLevelMenuId: number | null = null;
  activeItem: any = null;
  subMenuId: any[] = [];
  url:any;

constructor() {
  // this.sidebarOpen = false;
  this.showLogo = false;
  this.rightSidebarOpen = false;
  this.navigationId = new EventEmitter<number>();
  this.url = location.pathname; 

} 

  // sidebarToggle() {
  //   this.sidebarOpen = !this.sidebarOpen;
  //   this.showLogo = !this.showLogo;
  // }
  
  // rightSidebarToggle() {
  //   this.rightSidebarOpen = !this.rightSidebarOpen;
  //   this.showLogo = !this.showLogo;
  // }

  handleClick(item: any) {
    if (item.children) {
      this.openGrandChildren(item);
    } else {
      this.navigateChildTo(item);
    }
  }

  handleGrandChildClick(item: any) {
    if (item.children) {
      this.openThirdLevelChildren(item);
    } else {
      this.navigateGrandChildTo(item);
    }
  }

  handleparentClick(i: any) {
    this.grandChildActiveId = null;
    this.thirdLevelActiveId = null;
    this.childActiveId = null;
    if (i.children) {
      this.openChildren(i);
    } else {
      this.navigateTo2(i);
    }
  }

  // handlesecondClick(i: any) {
  //   if (i.children) {
  //     this.openChildren(i);
  //   } else {
  //     this.navigateTo2(i);
  //   }
  // }

  navigateTo(item: any) {
    this.sidebarOpen = false;
    this.navigationId.emit({id: item, sidebarOpen: false});
    this.activeId = item.itemId;
    if(item.secondLevelMenu) {
      this.secondLevelMenuId = this.secondLevelMenuId === item.itemId ? null : item.itemId;
      // this.secondLevelMenu = !this.secondLevelMenu;
    }
  }

  navigateTo2(item: any) {
    // this.sidebarOpen = false;
    this.activeId2 = item.itemId;
    this.url = item.path;    
    if(item.secondLevelMenu) {
      // this.sidebarOpen = true;
      if(this.subMenuId.includes(item.itemId)) {
        this.subMenuId = this.subMenuId.filter((i: any) => i != item.itemId)
      } else {
        this.subMenuId.push(item.itemId)
      }
    } else {
      this.sidebarOpen = false;
    }
    this.navigationId.emit({id: item, sidebarOpen: this.sidebarOpen});
  }

  navigateChildTo(item: any) {
    this.childActiveId = item.itemId;
    if(item.secondLevelMenu) {
      this.sidebarOpen = true;
      if(this.subMenuId.includes(item.itemId)) {
        this.subMenuId.filter((i: any) => i == item.itemId)
      } else {
        this.subMenuId.push(item.itemId)
      }
    } else {
      this.sidebarOpen = false;
    }
    this.navigationId.emit({id: item, sidebarOpen: this.sidebarOpen});
  }

  navigateGrandChildTo(item: any) {
    this.grandChildActiveId = item.itemId;
    if(item.secondLevelMenu) {
      this.sidebarOpen = true;
      if(this.subMenuId.includes(item.itemId)) {
        this.subMenuId.filter((i: any) => i == item.itemId)
      } else {
        this.subMenuId.push(item.itemId)
      }
    } else {
      this.sidebarOpen = false;
    }
    this.navigationId.emit({id: item, sidebarOpen: this.sidebarOpen});
  }

  navigateThirdLevelChildTo(item: any) {
    this.thirdLevelActiveId = item.itemId;
    if(item.secondLevelMenu) {
      this.sidebarOpen = true;
      if(this.subMenuId.includes(item.itemId)) {
        this.subMenuId.filter((i: any) => i == item.itemId)
      } else {
        this.subMenuId.push(item.itemId)
      }
    } else {
      this.sidebarOpen = false;
    }
    this.navigationId.emit({id: item, sidebarOpen: this.sidebarOpen});
  }

  // openChildren(itemId: any) {
  //   this.childrenOpened = !this.childrenOpened;
  //   if (this.activeId === itemId) {
  //     this.activeId = null; // Close if already open
  //     // this.childrenOpened = !this.childrenOpened;
  //   } else {
  //     this.activeId = itemId; // Open the selected item
  //   }
  // }

  itemsState: { [key: string]: boolean } = {};
  childItemsState: { [key: string]: boolean } = {};
  thirdLevelItemsState: { [key: string]: boolean } = {};

  openChildren(item: any) {
    this.sidebarOpen = true;
    if (this.activeId2 === item.itemId) {
      this.itemsState[item.itemId] = false;
      this.activeId2 = null;
    } else {
      this.itemsState[this.activeId2] = false;
      this.itemsState[item.itemId] = true;
      this.activeId2 = item.itemId;
    }
  }

  openGrandChildren(item: any) {
    if (this.childActiveId === item.itemId) {
      this.childItemsState[item.itemId] = false;
      this.childActiveId = null;
    } else {
      this.childItemsState[this.childActiveId] = false;
      this.childItemsState[item.itemId] = true;
      this.childActiveId = item.itemId;
    }
  }

  openThirdLevelChildren(item: any) {
    if (this.grandChildActiveId === item.itemId) {
      this.thirdLevelItemsState[item.itemId] = false;
      this.grandChildActiveId = null;
    } else {
      this.thirdLevelItemsState[this.grandChildActiveId] = false;
      this.thirdLevelItemsState[item.itemId] = true;
      this.grandChildActiveId = item.itemId;
    }
  }

  isChildrenOpened(itemId: any): boolean {
    return this.itemsState[itemId] || false;
  }

  isGrandChildrenOpened(itemId: any): boolean {
    return this.childItemsState[itemId] || false;
  }

  isThirdLevelChildrenOpened(itemId: any): boolean {
    return this.thirdLevelItemsState[itemId] || false;
  }
  
}
